export const initialise = () => {
    markActivePacContainer();
    removeActiveClassOnScroll();
    observePacContainers();
};

const markActivePacContainer = (): void => {
    const locationInputs = document.querySelectorAll<HTMLInputElement>(
        ".location-search-input"
    );

    locationInputs.forEach(input => {
        input.addEventListener("input", () => {
            setTimeout(() => {
                addActiveClassToPacContainer();
            }, 500);
        });
        input.addEventListener("focus", () => {
            setTimeout(() => {
                addActiveClassToPacContainer();
            }, 500);
        });
    });
};

const addActiveClassToPacContainer = (): void => {
    const pacContainers = document.querySelectorAll<HTMLDivElement>(".pac-container");
    
    pacContainers.forEach(container => {
        if (
            container.style.display !== "none" &&
            !container.classList.contains("active-search-container")
        ) {
            container.classList.add("active-search-container");
        }
    });
};

const observePacContainers = (): void => {
    const observer = new MutationObserver(() => {
        const pacContainers = document.querySelectorAll<HTMLDivElement>(".pac-container");
        
        pacContainers.forEach(container => {
            if (container.style.display === "none") {
                container.classList.remove("active-search-container");
            }
        });
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true
    });
};

const removeActiveClassOnScroll = (): void => {
    window.addEventListener("scroll", () => {
        const activeContainers = document.querySelectorAll<HTMLDivElement>(
            ".active-search-container"
        );
        
        activeContainers.forEach(container => {
            container.style.display = "none";
            container.classList.remove("active-search-container");
        });
    });
};